module.exports = {"Death1":{"daobanList":[{"title":"1:是否办理国（境）内出生登记(随第三方入户登记)","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、自然人“身后事一站式”联办登记表","state":"必要"},{"name":"2、居民死亡医学（推断书）","state":"必要"},{"name":"3、居民户口簿","state":"必要"},{"name":"4、居民身份证","state":"必要"},{"name":"5、身份证件（委办人）","state":"必要"},{"name":"6、办理户籍事项承诺书","state":"必要"},{"name":"7、变更户主情况登记表","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdd-1.json
// module id = 1239
// module chunks = 0